(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swa-motion-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-swa-motion]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    roots.forEach((root) => {
      const revealItems = root.querySelectorAll('[data-reveal]');

      if (!reduceMotion && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.16 });

        revealItems.forEach((item) => observer.observe(item));
      } else {
        revealItems.forEach((item) => item.classList.add('is-visible'));
      }

      if (reduceMotion) return;

      const parallaxItems = root.querySelectorAll('[data-parallax]');
      let ticking = false;

      const updateParallax = () => {
        const viewportCenter = window.innerHeight * 0.5;

        parallaxItems.forEach((item) => {
          const rect = item.getBoundingClientRect();
          const itemCenter = rect.top + rect.height * 0.5;
          const speed = Number.parseFloat(item.dataset.parallax || '0');
          const offset = Math.max(-90, Math.min(90, (itemCenter - viewportCenter) * speed));
          item.style.setProperty('--parallax', `${offset}px`);
        });

        ticking = false;
      };

      const requestTick = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateParallax);
      };

      updateParallax();
      window.addEventListener('scroll', requestTick, { passive: true });
      window.addEventListener('resize', requestTick, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
